import moment from 'moment';

export const getOidcStorageKey = () => {
    const authSettings = JSON.parse(localStorage.getItem('authSettings'));
    if (authSettings) {
        return `oidc.user:${authSettings.auth_server}:${authSettings.client_id}`;
    }
    return null;
};

export const getOidcInfo = () => {
    const key = getOidcStorageKey();
    if (key) {
        const oidc = JSON.parse(localStorage.getItem(key));
        return oidc;
    }
    return null;
};

export const getToken = () => {
    const oidc = getOidcInfo();
    if (oidc) {
        return oidc.id_token;
    }
    return null;
};

// eslint-disable-next-line arrow-parens
export const setCurrencyFormat = (value, append) => {
    if (value) {
        return `${append ? "$" : ""} ${value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}`
    }

    return 0
}

// eslint-disable-next-line arrow-parens
export const setCurrencyFormatInWon = (value, append) => {
    if (value) {
        return `${append ? "₩" : ""} ${value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}`
    }

    return 0
}

export const findMonthsBetweenDates = (startDate, endDate, format) => {
    const allMonthsInPeriod = [];
    let date1 = moment(startDate, 'YYYY-MMM').startOf('month');
    const date2 = moment(endDate, 'YYYY-MMM').endOf('month');
    while (date1.isBefore(date2)) {
        allMonthsInPeriod.push(date1.format(format || "YYYY-MMM"));
        date1 = date1.add(1, "month");
    };

    return allMonthsInPeriod
}

export const findYearsBetweenDates = (startDate, endDate, format) => {
    const allYearsInPeriod = [];
    let date1 = moment(startDate, 'YYYY').startOf('year');
    const date2 = moment(endDate, 'YYYY').endOf('year');
    while (date1.isBefore(date2)) {
        allYearsInPeriod.push(date1.format(format || "YYYY"));
        date1 = date1.add(1, "year");
    };

    return allYearsInPeriod
}

export const getMonths = (start, end) =>
    Array.from({ length: end.diff(start, 'month') + 1 }).map((_, index) =>
        moment(start).add(index, 'month').format('MMM-YYYY'));
export const getYears = (start, end) =>
        Array.from({ length: end.diff(start, 'year') + 1 }).map((_, index) =>
            moment(start).add(index, 'year').format('YYYY'));

export const colorsCombination = {
    0: ['#3366ff',
        '#39e600',
        '#b133ff',],

    1: ['#DC67CE',
        '#6794DC',
        '#DC6788',],
    2: ['#DC6967',
        '#DC67AB',
        '#DCAF67',],
    3: ['#DCD267',
        '#6794DC',
        '#A0DC67',],
    4: ['#C3DC67',
        '#F59380',
        '#67DC98',],

    5: ['#67DCBB',
        '#F5B480',
        '#80D2F5',
    ],
    6: ['#80B0F5',
        '#DC6788',
        '#9380F5',],
    7: ['#F5D680',
        '#D680F5',
        '#F580F3',],
    8: ['#F580D2',
        '#B0F580',
        '#F5808F',
    ],
    9: ['#F59380',
        '#C3DC67',
        '#F5D680',],
    10: ['#D2F580',
        '#67DADC',
        '#8FF580',],

}

export const colorArray = [

    '#8067DC',
    '#A367DC',
    '#C767DC',
    '#DC67CE',
    '#DC67AB',
    '#DC6788',
    '#DC6967',
    '#DC8C67',
    '#DCAF67',
    '#DCD267',
    '#C3DC67',
    '#A0DC67',
    '#7DDC67',
    '#67DC75',
    '#67DC98',
    '#67DCBB',
    '#67DADC',
    '#80D2F5',
    '#80B0F5',
    '#808FF5',
    '#9380F5',
    '#B480F5',
    '#D680F5',
    '#F580F3',
    '#F580D2',
    '#F580B0',
    '#F5808F',
    '#F59380',
    '#F5B480',
    '#F5D680',
    '#F3F580',
    '#D2F580',
    '#B0F580',
    '#8FF580',
    '#80F593',
    '#80F5B4',
    '#80F5D6',
    '#80F3F5',
    '#8CEEFF',
    '#8CDEFF',
    '#8CCDFF',
    '#8CBCFF',
    '#8CABFF',
    '#8C9BFF',
    '#8E8CFF',
    '#9F8CFF',
    '#AF8CFF',
    '#C08CFF',
    '#D18CFF',
    '#E28CFF',
    '#F28CFF',
    '#FF8CFF',
    '#FF8CEE',
    '#FF8CDE',
    '#FF8CCD',
    '#FF8CBC',
    '#FF8CAB',
    '#FF8C9B',
    '#FF8E8C',
    '#FF9F8C',
    '#FFAF8C',
    '#FFC08C',
    '#FFD18C',
    '#FFE28C',
    '#FFF28C',
    '#FFFF8C',
    '#EEFF8C',
    '#DEFF8C',
    '#CDFF8C',
    '#BCFF8C',
    '#ABFF8C',
    '#9BFF8C',
    '#8CFF8E',
    '#8CFF9F',
    '#8CFFAF',
    '#8CFFC0',
    '#8CFFD1',
    '#8CFFE2',
    '#8CFFF2',
    '#8CFFFF',
    '#93FEFF',
    '#93F6FF',
    '#93EDFF',
    '#93E5FF',
    '#93DDFF',
    '#93D5FF',
    '#93CCFF',
    '#93C4FF',
    '#93BCFF',
    '#93B4FF',
    '#93ACFF',
    '#93A3FF',
    '#939BFF',
    '#9393FF',
    '#9B93FF',
    '#A393FF',
    '#AC93FF',
];;
// eslint-disable-next-line implicit-arrow-linebreak

export const numToStringFormatter = (num, digits) => {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().reverse().find(data => num >= data.value);
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export const addAlpha = (color, opacity) => {
    // coerce values so ti is between 0 and 1.
    const opa = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + opa.toString(16).toUpperCase();
}